import {
	Button,
	Space,
	Spin,
	Typography,
} from 'antd';
import type { FC } from 'react';
import PageContainer from '@ui/PageContainer';
import PageTitle from '@ui/PageTitle';
import Section from '@ui/Section';
import useHomePage from './useHomePage';

const { Title, Text, Paragraph } = Typography;

const HomePage: FC = () => {
	const {
		count,
		increment,
		decrement,
		sample,
		isSampleLoading,
	} = useHomePage();

	return (
		<PageContainer>
			<PageTitle documentTitle="Home">cs-fctg-services-authorization-frontend</PageTitle>
			<Paragraph>
				This page exercises Jotai (counter), React Query (mock fetch), and Ant Design
				(layout primitives). Replace it with your own routes.
			</Paragraph>
			<Section>
				<Title level={3}>Counter (Jotai)</Title>
				<Space>
					<Button onClick={decrement}>-</Button>
					<Text
						strong
						data-testid="counter-value"
					>
						{count}
					</Text>
					<Button onClick={increment}>+</Button>
				</Space>
			</Section>
			<Section>
				<Title level={3}>Mock fetch (React Query)</Title>
				{isSampleLoading ? (
					<Spin />
				) : (
					<Text data-testid="sample-message">{sample?.message ?? 'no response'}</Text>
				)}
			</Section>
		</PageContainer>
	);
};

export default HomePage;
